// Atlas Vaelo — section-level scroll reveal.
//
// Per-section progress: every [data-reveal] element runs its own 0 -> 1 as it rises
// through the viewport, so there is no dead zone. Reads and writes are split into two
// phases inside one rAF; only elements near the viewport are measured (IO, 200px margin),
// capped at 12 per frame.
//
// THREE RULES THIS FILE MUST NEVER BREAK
//   1. Binding is idempotent and RE-RUNNABLE. The host re-renders the template, which
//      replaces the section nodes. Anything that latches after the first pass leaves the
//      observer watching detached nodes while the live ones stay hidden forever.
//   2. The hiding class goes on only AFTER at least one live node is observed, and it is
//      removed the moment nothing is being watched.
//   3. A watchdog releases anything still hidden and unmeasured after 1.5s. Content
//      visibility must never depend on an observer firing.
//
// findScroller is load-bearing on Shopify: Horizon scrolls .page-wrapper, not the window.
(function () {
  var REDUCE = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var MOBILE = window.matchMedia && matchMedia('(max-width: 768px)').matches;

  // re-entry from a second evaluation just re-binds against the current DOM
  if (window.__avReveal && window.__avReveal.rebind) { window.__avReveal.rebind(); return; }

  var near = [];             // elements currently near the viewport
  var seen = new WeakSet();  // nodes already handed to an observer
  var touched = new WeakSet(); // nodes that have received an inline opacity
  var raf = 0, evts = 0, lastRef = null, container = null, tail = 0;
  var io = null, mio = null, watchdog = 0, observing = 0, polling = false;

  function clamp01(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }

  function release(el) {
    el.style.opacity = '';
    el.style.transform = '';
    el.setAttribute('data-reveal', '1');
  }
  function showAll(els) { for (var i = 0; i < els.length; i++) release(els[i]); }

  function hideClass(on) {
    document.documentElement.classList[on ? 'add' : 'remove']('js-reveal');
  }

  function apply() {
    raf = 0;
    if (!near.length) return;

    var vh = window.innerHeight;
    var start = vh * 1.0, end = vh * 0.22, span = start - end;
    var batch = [], i, n = Math.min(near.length, 12);

    // phase 1: read only
    for (i = 0; i < n; i++) {
      var el = near[i];
      if (!el.isConnected) continue;
      var r = el.getBoundingClientRect();
      batch.push([el, clamp01((start - r.top) / span)]);
    }
    // phase 2: write only — no layout is read after this point
    for (i = 0; i < batch.length; i++) {
      var e = batch[i][0], p = batch[i][1];
      e.style.opacity = p.toFixed(3);
      e.style.transform = 'translateY(' + ((1 - p) * 48).toFixed(2) + 'px)';
      touched.add(e);
    }
  }

  function request() { if (!raf) raf = requestAnimationFrame(apply); }

  function onScroll() {
    evts++;
    request();
    // the host's scroll is animated, so the last event fires before motion stops:
    // guarantee one trailing frame at the true final position
    clearTimeout(tail);
    tail = setTimeout(apply, 140);
  }

  // Fallback for hosts that scroll a container outside this document, so no scroll event
  // ever reaches us. Samples a STATIC element (never one we transform) and stops for good
  // as soon as a real scroll event arrives.
  function poll() {
    if (evts > 0) { polling = false; return; }
    var ref = document.querySelector('header') || document.body;
    if (!document.hidden && ref) {
      var top = ref.getBoundingClientRect().top;
      if (lastRef === null || Math.abs(top - lastRef) > 0.5) { lastRef = top; apply(); }
    }
    requestAnimationFrame(poll);
  }

  // Nothing may stay invisible. Anything still at data-reveal="0" that no observer has
  // ever measured gets released outright.
  function arm() {
    clearTimeout(watchdog);
    watchdog = setTimeout(function () {
      var stuck = document.querySelectorAll('[data-reveal="0"]'), any = false;
      for (var i = 0; i < stuck.length; i++) {
        if (!touched.has(stuck[i])) { release(stuck[i]); any = true; }
      }
      if (any || !observing) hideClass(false);
    }, 1500);
  }

  // Idempotent: safe to call on every mutation. Only NEW nodes are bound.
  function bind() {
    var els = document.querySelectorAll('[data-reveal]');
    if (!els.length) { hideClass(false); return; }

    // reduced motion or no IO -> content simply visible, never hidden
    if (REDUCE || !window.IntersectionObserver) { hideClass(false); showAll(els); return; }

    // A target that CONTAINS another target hands the motion down to its children, so a
    // tall section never swallows the animation of the modules inside it.
    var i, fresh = [];
    for (i = 0; i < els.length; i++) {
      if (seen.has(els[i])) continue;
      if (els[i].querySelector('[data-reveal]')) { release(els[i]); seen.add(els[i]); continue; }
      if (els[i].getAttribute('data-reveal') !== '0') { seen.add(els[i]); continue; }
      fresh.push(els[i]);
    }
    if (!fresh.length) { arm(); return; }

    if (MOBILE) {
      // one-shot fade, no continuous work on phones.
      // threshold MUST be 0: a section can be taller than the viewport, and any
      // percentage of it would then be unsatisfiable and the section never appears.
      if (!mio) {
        mio = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (e.isIntersecting) { touched.add(e.target); release(e.target); mio.unobserve(e.target); }
          });
        }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });
      }
      for (i = 0; i < fresh.length; i++) { mio.observe(fresh[i]); seen.add(fresh[i]); observing++; }
      hideClass(true);
      arm();
      return;
    }

    if (!io) {
      io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var at = near.indexOf(e.target);
          if (e.isIntersecting) { if (at < 0) near.push(e.target); }
          else if (at >= 0) near.splice(at, 1);
        });
        request();
      }, { rootMargin: '200px 0px' });
    }
    for (i = 0; i < fresh.length; i++) { io.observe(fresh[i]); seen.add(fresh[i]); observing++; }

    // only hide once something live is actually being watched
    hideClass(true);

    if (!container) {
      container = findScroller(fresh[0]);
      if (container) container.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('scroll', onScroll, { passive: true });
      document.addEventListener('scroll', onScroll, { passive: true, capture: true });
      window.addEventListener('resize', request);
    }
    if (!polling) { polling = true; poll(); }

    apply();
    arm();
  }

  function findScroller(el) {
    for (var n = el && el.parentElement; n && n !== document.body; n = n.parentElement) {
      var o = getComputedStyle(n).overflowY;
      if ((o === 'auto' || o === 'scroll') && n.scrollHeight > n.clientHeight + 4) return n;
    }
    var de = document.scrollingElement || document.documentElement;
    return (de.scrollHeight > de.clientHeight + 4) ? de : null;
  }

  window.__avReveal = { rebind: bind };

  // A re-render swaps the section nodes out. Re-bind against whatever is on screen now.
  var pending = 0;
  if (window.MutationObserver) {
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(bind, 60);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  bind();
  // the template may still be streaming: keep looking for sections for a few seconds
  var tries = 0;
  var timer = setInterval(function () { bind(); if (++tries > 24) clearInterval(timer); }, 200);
})();
